import { useCallback, useMemo } from 'react';

import { useSearchPageData } from '#src/app/pages/search/pageContext';
import {
	SEARCH_DECISION_MAKERS_INDEX_NAME,
	SEARCH_INDEX_NAME_BASE,
	SEARCH_PRESET_BASE,
	SEARCH_VECTOR_COLLECTION_LANGUAGES,
	SEARCH_VECTOR_INDEX_NAME_BASE,
	SEARCH_VECTOR_PRESET_BASE,
} from '#src/app/pages/search/shared/consts';
import { useLocale } from '#src/app/shared/hooks/l10n';
import { useTypesenseConfig } from '#src/app/shared/hooks/typesense';

type Result = ModelHookResult<{
	searchIndexName: string;
	searchPreset: string;
	decisionMakersIndexName: string;
}>;

export function useSearchIndexName(): Result {
	const locale = useLocale();
	const [language] = locale.split('-');

	const { namespace } = useTypesenseConfig();

	const {
		data: {
			featureConfigs: { useVectorCollection },
		},
	} = useSearchPageData();

	const useVectorCollectionForLanguage = useVectorCollection && SEARCH_VECTOR_COLLECTION_LANGUAGES.includes(language);

	const addNamespace = useCallback(
		(indexName: string): string => {
			return namespace ? `${namespace}_${indexName}` : indexName;
		},
		[namespace],
	);

	return {
		data: useMemo(() => {
			return {
				searchIndexName: addNamespace(
					`${useVectorCollectionForLanguage ? SEARCH_VECTOR_INDEX_NAME_BASE : SEARCH_INDEX_NAME_BASE}${language}`,
				),
				searchPreset: addNamespace(
					`${useVectorCollectionForLanguage ? SEARCH_VECTOR_PRESET_BASE : SEARCH_PRESET_BASE}${language}`,
				),
				decisionMakersIndexName: addNamespace(SEARCH_DECISION_MAKERS_INDEX_NAME),
			};
		}, [addNamespace, language, useVectorCollectionForLanguage]),
	};
}
